const RELOAD_KEY = 'chunk-load-error-reload';

function hasMessage(value: unknown): value is { message?: string } {
  return typeof value === 'object' && value !== null && 'message' in value;
}

function hasName(value: unknown): value is { name?: string } {
  return typeof value === 'object' && value !== null && 'name' in value;
}

function matchesChunkMessage(message?: string): boolean {
  if (!message) {
    return false;
  }

  return (
    message.includes('Loading chunk') ||
    message.includes('ChunkLoadError') ||
    message.includes('Unexpected token') ||
    message.includes('Failed to fetch dynamically imported module')
  );
}

export function handleChunkLoadError(): boolean {
  const hasReloaded = sessionStorage.getItem(RELOAD_KEY);

  if (!hasReloaded) {
    sessionStorage.setItem(RELOAD_KEY, 'true');
    console.log('Chunk load error detected - reloading to get latest version...');
    window.location.reload();
    return true;
  }

  sessionStorage.removeItem(RELOAD_KEY);
  return false;
}

export function isChunkLoadError(error: unknown, fallbackMessage?: string): boolean {
  if (matchesChunkMessage(fallbackMessage)) {
    return true;
  }

  const errorMessage = hasMessage(error) ? error.message : undefined;
  const errorName = hasName(error) ? error.name : undefined;

  return matchesChunkMessage(errorMessage) || errorName === 'ChunkLoadError';
}

export function resetChunkReloadFlag(): void {
  sessionStorage.removeItem(RELOAD_KEY);
}
